import { handleService } from './common'

const prefix = '/api/Authenticate'

const url = {
  login: prefix + '/Login',
  getCode: prefix + '/GetCore'
}

export default {
  login (data) {
    return handleService(url.login, data, 'POST')
  },
  getCode (data) {
    return handleService(url.getCode, data)
  }
}
